import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('arkora_cookie_consent');
    if (!consent) {
      // Delay showing the banner for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('arkora_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('arkora_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent" data-testid="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-icon">
          <Cookie size={24} />
        </div>
        <div className="cookie-text">
          <h4>Cookie Notice</h4>
          <p>
            ARKORA uses essential cookies and basic analytics to improve website 
            performance and user experience. These cookies do not personally identify you.
          </p>
        </div>
        <div className="cookie-actions">
          <Link to="/legal#cookies" className="cookie-link">
            Learn more
          </Link>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Decline
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accept
          </button>
        </div>
        <button className="cookie-close" onClick={handleDecline} aria-label="Close">
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
